import { PAYMENTS_INFO_KEY } from '@pflegenavi/frontend/api-nursing-home';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/** Shows the KYC-blocked error and refetches the resident's payment preconditions. */
export const useNotifyLegalEntityKycBlocked = (
  residentId: string | undefined
): (() => void) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useCallback(() => {
    enqueueSnackbar(t('payments.legal-entity-not-kyc-verified'), {
      variant: 'error',
    });
    void queryClient.invalidateQueries({
      queryKey: PAYMENTS_INFO_KEY(residentId),
    });
  }, [enqueueSnackbar, queryClient, residentId, t]);
};
